module.exports = __webpack_public_path__ + "static/img/close.e81e286.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/assets/close.png
// module id = M/Fz
// module chunks = 0